import React, { useState, useEffect, memo } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import axios from "axios";
import $ from 'jquery';
import './panel.css';
import frm from './formAux.js'

var descriptor = {};
var origDescriptor = null;

var availModels = {};

function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring(o) { return typeof (o) == 'string'; }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o instanceof Object && !isarray(o); }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig, '').toLowerCase() }
function iarray(v, n) {
    var ret = [];
    for (var i = 0; i < n; i++)
        ret.push(v instanceof Object ? clone(v) : v);
    return ret;
}

function exists(o) {
    if (!o) return false;
    if (!isobj(o)) return false;
    return Object.keys(o).length > 0;
}

function defaultCkeckboxes() {
    // frm.booleanList( $('.project-settings2-bool'), frm.arr2Bool(descriptor.checkboxes_set), {
    // 	items: desc,
    // 	header: ['','Default toolbar checkbox values'],
    // 	callbackOnInit: true,
    // 	forceHeader: true,
    // }, function(o){
    // 	descriptor.checkboxes_set = frm.bool2Arr(o);
    // } );
}

function getConfig() {

}

function exportConfig() {
}

var config = {
    "webPath": "http://localhost:8080/",
    "deepLinkPath": "http://localhost:8080/",
    "servicePath": "http://localhost:8088/",
    "apiPath": "http://localhost:8089/v1",
    "signedPath": "http://localhost:8090/",
    // "signedPath": "http://34.198.138.75:8090/",

    "newtonApiPath": "http://127.0.0.1:8999/",
    "emailDomainLink": "localhost:8080",
    "endpointURL": "",
    "sessionTimeout": 180,
    "allowSetupUser": true,
    "mongoHost": "localhost",
    "mongoPort": "27017",
    "mongoSchema": "adl",
    "mongoUser": "",
    "mongoPassword": "",
    "mongoTlsCAFile": "",
    "azureClientId": "",
    "azureAuthorityPath": "",
    "password": {
        "minLength": 8,
        "minUpper": 0,
        "minLower": 0,
        "minDigit": 0,
        "minSymbol": 0,
        "maxRepeat": 0,
        "maxSequence": 0,
        "allowExtendedChars": false,
        "allowSpaces": false,
        "checkDictionary": false,
        "maxContinuousType": 0,
        "checkLast3Passwords": false,
        "forcePasswordChange": 0,
    }
}

window.ccc = config;

function flatObject(o, maxLevel) {
    var list = {};
    if (!maxLevel) maxLevel = 1000;
    function walk(o, path, list) {
        // console.log( 'walk', path, path.length )
        if (path.length >= maxLevel) {
            list[path.join('.')] = o;
            // console.log( 'listtttt', path.join('.'), o )
            return;
        }
        if (isobj(o)) {
            for (var k in o) {
                walk(o[k], path.concat(k), list)
            }
        }
        else if (isarray(o)) {
            for (var i = 0; i < o.length; i++)
                walk(o[i], path.concat(i), list)
        }
        else {
            if (isstring(o)) {
                try {
                    o = JSON.parse(o);
                    walk(o, path, list)
                }
                catch (e) { }
            }
            if (isobj(o) || isarray(o)) walk(o, path, list)
            else {
                list[path.join('.')] = o;
                // console.log( 'list', path.join('.'), o )
            }

        }
    }
    walk(o, [], list);
    return list;
}

function setObject(o, k, v) {
    // console.log( 'setObjecdt', k, v )
    var path = k.split('.');
    while (path.length > 1) {
        var p = path.shift();
        if (!o[p]) o[p] = {};
        o = o[p];
    }
    var p = path.shift();
    o[p] = v;
}

function getInput(inpt) {
    if (inpt.prop('type') == 'checkbox') return inpt.prop('checked')
    return inpt.val();
}

function setInput(inpt, v) {
    if (inpt.prop('type') == 'checkbox') return inpt.prop('checked', v)
    inpt.val(v);
}

function ckGroups() {
    if (!config.ssoGroups || !Object.keys(config.ssoGroups).length) return false;
    for (let g of Object.values(config.ssoGroups)) {
        if (!g.origin || !g.name || !g.role) {
            frm.myAlert('SSO Groups', 'There are incomplete data on the SSO Group definitions. Please fill in all necessary information');
            return true;
        }
    }
    return false;
}

function Config(prop) {

    const [showPass, setShowPass] = useState(true);

    async function saveConfig() {
        if (ckGroups()) return;

        if( (config.servicesPrivateKey || '').match(/^base64:/) || (config.servicesPublicCertificate||'').match(/^base64:/) ) {
            if( !(await frm.myConfirm('Service Certificate Change', 'You are changing the certificates for the overall services. All services must be <b>restarted</b>. If your system is running under <b>ECS</b>, please restart all service tasks after this change.') ) ) return;
        }

        frm.myAlert('Save System Configuration', 'Are you sure you want to save the current configuration?', 'Yes, save configuration', async function (ev) {
            // ev.stopPropagation();
            // ev.preventDefault();
            await frm.myAlertClose();
            console.log('saveconfigxx', JSON.stringify(config))
            // alert(JSON.stringify(config, null, "\t"))
            await window.post('set_config', { config: config });
            frm.loading('Restarting application.<br>Please wait...')
            setTimeout(function () {
                document.location.reload();
            }, 5000)
        }, 'Cancel')
    }

    async function showConfig() {
        $('#savebtn').off('click').on('click', saveConfig)
        var fconf = flatObject(config);
        console.log('fconf', fconf)
        // check for new configurations in form
        let inputs = Array.from($('input'));
        for (let i of inputs) {
            let id = i.id || '';
            let k = id.split('_');
            if (k[0] == 'cfg') {
                k = k.splice(1).join('.')
                if (!(k in fconf)) {
                    console.log('iiiiiiiiiiiiii', k)
                    fconf[k] = null;
                }
            }
        }

        for (var k in fconf) {
            var ikey = 'cfg_' + k.replace(/\./g, '_');
            var inpt = $('#' + ikey);
            // console.log( 'key', ikey, inpt[0] )
            var type = inpt.attr('type');
            inpt.prop('key', k)
            if (type == 'text ') inpt.css({ width: 500 })
            else if (type == 'number') inpt.css({ width: 100 })
            inpt.off('change').on('change', function () {
                var v = getInput($(this));
                var k = $(this).prop('key');
                if ($(this).prop('type') == 'number') {
                    v = v * 1 || 0;
                    if (v < 0) v = 0;
                }
                // console.log( 'change', k, v )
                // if( v != '' ) 
                setObject(config, k, v);
                setInput($(this), v)
            })
            setInput(inpt, fconf[k])
            // console.log( 'key', k, )
        }

        //// SERVICES CONFIG
        let srvc = frm.configSection($('.panel2'), 'Services Config', false);
        let srvconfig = [
            // {
            //     "key": "testFile",
            //     "title": "TestFile",
            //     "button": "Upload Private PEM Key",
            //     "type": "file",
            //     "ext": ".pem,.key,.crt",
            // },
            {
                "key": "webPath",
                "title": "Web Path URL",
                "type": "string",
            },
            {
                "key": "servicePath",
                "title": "Service Path URL",
                "type": "string",
            },
            {
                "key": "apiPath",
                "title": "API Path URL",
                "type": "string",
            },
            {
                "key": "signedPath",
                "title": "Document Signed Path URL",
                "type": "string",
            },
            {
                "key": "deepLinkPath",
                "title": "Deeplink Path URL",
                "type": "string",
            },
            {
                "key": "newtonApiPath",
                "title": "Newton-ml Internal Path URL",
                "type": "string",
            },
            // {
            //     "key": "emailDomainLink",
            //     "title": "Email domain link (only domain/port)",
            //     "type": "string",
            // },
            {
                "key": "sessionTimeout",
                "title": "Session timeout (in minutes)",
                "type": "number",
                "default": 180,
            },
            {
                "key": "allowSetupUser",
                "label": "Allow Default Setup User",
                "type": "boolean",
                "default": true,
            },
            {
                "key": "servicesPrivateKey",
                "title": "Services Private PEM Key (optional)",
                "button": "Upload Private PEM Key",
                "type": "file",
                "ext": ".pem,.key,.crt",
            },
            {
                "key": "servicesPublicCertificate",
                "title": "Services Public PEM Certificate (optional)",
                "button": "Upload Public PEM Key",
                "type": "file",
                "ext": ".pem,.key,.crt",
            },
        ]
        frm.configOptions(srvc, srvconfig, config);


        // DATABASE SETTINGS
        let dbs = frm.configSection($('.panel2'), 'Database Settings', false);
        let dbsconfig = [
            {
                "key": "mongoHost",
                "title": "Database Host",
                "label": "Database Host",
                "placeholder": "enter ip or domain",
                "type": "string",
            },
            {
                "key": "mongoPort",
                "title": "Database Port",
                "label": "Database Port",
                "placeholder": "enter port number Ex.: 27018",
                "type": "int",
            },
            {
                "key": "mongoSchema",
                "title": "Database Schema",
                "label": "Database Schema",
                "placeholder": "enter schema Ex.: adl",
                "type": "string",
            },
            {
                "key": "mongoUser",
                "title": "Database User (optional)",
                "label": "Database User (optional)",
                "placeholder": "enter optional user",
                "type": "string",
            },
            {
                "key": "mongoPassword",
                "title": "Database Password (optional)",
                "label": "Database Password (optional)",
                "placeholder": "enter optional password",
                "type": "string",
            },
            {
                "key": "mongoTlsCAFile",
                "title": "TLS CA File (optional)",
                "button": "Upload TLS PEM",
                "fileName": 'database_tls.pem',
                "type": "file",
                "ext": ".pem,.key",
            },
            {
                "key": "mongoTunnelUserHost",
                "title": "Tunneling user@host (optional)",
                "label": "Tunneling user@host (optional)",
                "placeholder": "enter tunnel user@host",
                "type": "string",
            },
            {
                "key": "mongoTunnelCert",
                "title": "Tunneling Cert File",
                "label": "Tunneling Cert File",
                "placeholder": "enter cert file name Ex.: tunnel.pem",
                "type": "string",
            },
        ]
        frm.configOptions(dbs, dbsconfig, config);


        /// EMAIL SETTINGS
        let em = frm.configSection($('.panel2'), 'Email Settings', false);
        let emmconfig = [
            {
                "key": "email.from",
                "title": "Email Sender",
                "label": "Global Email sender account (from)",
                "placeholder": "Enter global Email",
                "type": "email",
            },
            {
                "key": "email.smtp",
                "title": "SMTP Server",
                "label": "SMTP server",
                "placeholder": "Enter SMTP server domain",
                "type": "string",
            },
            {
                "key": "email.port",
                "title": "SMTP Port",
                "label": "SMTP Port",
                "placeholder": "Enter SMTP port",
                "type": "int",
            },
            {
                "key": "email.passwd",
                "title": "Password",
                "label": "Email password",
                "placeholder": "Enter email password",
                "type": "string",
            },
        ]
        frm.configOptions(em, emmconfig, config);


        //// AZURE SETTINGS

        // if (config.azureClientId) {
        //     config.azure = {
        //         SSOMode: 'OIDC',
        //         OIDC: {
        //             clientId: config.azureClientId,
        //             authorityPath: config.azureTenantId,
        //         }
        //     }
        //     delete config.azureClientId;
        //     delete config.azureAuthorityPath;
        // }


        let anc = frm.configSection($('.panel2'), 'Single Sign-on Settings', false);

        let azconfig = [
            {
                "title": "SSO Mode",
                "key": "azure.SSOMode",
                "type": "dropdown",
                "placeholder": "Select mode",
                "options": [
                    {
                        "value": "OIDC",
                        "label": "OpenID Connect - OIDC",
                        "subFields": [
                            {
                                "title": "Client ID",
                                "key": "azure.OIDC.clientId",
                                "placeholder": "Enter ClientID",
                                "type": "string"
                            },
                            {
                                "title": "Tenant ID",
                                "key": "azure.OIDC.tenantId",
                                "placeholder": "Enter TenantID",
                                "type": "string"
                            },                            {
                                "title": "Cloud Instance",
                                "key": "azure.OIDC.cloudInstance",
                                "placeholder": "Enter Cloud Instance URL",
                                "default": "https://login.microsoftonline.com/",
                                "type": "string"
                            },
                            {
                                "title": "Client Secret",
                                "key": "azure.OIDC.clientSecret",
                                "placeholder": "Enter Secret",
                                "type": "string"
                            }                            
                        ]
                    },
                    {
                        "value": "ADFS",
                        "label": "Active Directory Federation Services - ADFS",
                        "subFields": [
                            {
                                "title": "ADFS Instance URL",
                                "key": "azure.ADFS.instanceURL",
                                "placeholder": "Enter URL",
                                "type": "string"
                            },
                            {
                                "title": "Private Key",
                                "key": "azure.ADFS.privateKey",
                                "fileName": "azure_adfs_private.pem",
                                "button": "Upload PEM Private Key",
                                "ext": ".pem,.key",
                                "type": "file",
                            },
                            {
                                "title": "Certificate",
                                "key": "azure.ADFS.certificate",
                                "fileName": "azure_adfs_certificate.cer",
                                "button": "Upload CER Certificate",
                                "ext": ".cer",
                                "type": "file",
                            }
                        ]
                    }
                ]
            }
        ]
        frm.configOptions(anc, azconfig, config);




        ////// SSO GROUPS
        let gc = frm.configSection($('.panel2'), 'SSO Groups', false);
        let companies = [];
        try {
            companies = (await window.post('find_companies', { match: { active: true } })).data.records;
        }
        catch (e) { console.error(e) }
        let privs = [
            { value: 'team', text: 'Collaborator' },
            { value: 'admin', text: 'SuperUser' },
            // { value: 'c_admin', text: 'Company Admin' },
            // { value: 'nlp_qc', text: 'Reviewer (QC)' },
            // { value: 'c_super', text: 'Project Supervisor' },
            // { value: 'c_viewer', text: 'Project Viewer' },
            // { value: 'd_super', text: 'Dataset Supervisor' },
            // { value: 'd_viewer', text: 'Dataset Viewer' },
        ]
        let cadmins = [];
        companies.sort((a, b) => b.name.toLowerCase().localeCompare(a.name.toLowerCase()))
        for (let c of companies) {
            privs.splice(1, 0, { value: c._id, text: 'Company Admin (' + c.name + ')' })
        }
        // console.log('companies', companies)
        let gfields = {
            'origin': {
                type: 'option',
                placeholder: 'Select Label',
                label: 'Origin',
                className: 'option-model',
                default: 'azure',
                showOptionText: true,
                forceWidth: 100,
                css: { display: 'none' },
                options: [
                    { value: 'azure', text: 'Azure' },
                    // {value:'google',text:'Google'},
                ],
            },
            'name': { type: 'text', placeholder: 'Enter Group Name', fforceWidth: 300, label: 'Name' },
            'gid': { type: 'text', placeholder: 'Enter Origin Id', label: 'Id' },
            'role': {
                type: 'option',
                placeholder: 'Select Privilege',
                label: 'Role',
                className: 'option-model',
                default: '',
                showOptionText: true,
                forceWidth: 300,
                options: privs,
                forceWidth: 300,
            },
            'api': {
                label: "API",
                type: "boolean",
                forceWidth: 30, 
                css: {marginLeft: 10},
                default: false,
            },
        }
        let gconfig = [
            {
                "key": "ssoGroups",
                "fieldKey": 'gid',
                "defaultField": 'gid',
                // "title": "SSO Groups",
                "type": "gridlist",
                "fields": gfields,
                "arrayOutput": true,
            },
        ];
        // console.log( 'CONFIG', config.ssoGroups )
        frm.configOptions(gc, gconfig, config);


        /// EMBEDING SETTINGS
        let mv = frm.configSection($('.panel2'), 'Embedding Settings', false);
        let mvconfig = [
            {
                "key": "milvus.endpoint",
                "title": "Milvus Host",
                "label": "",
                "placeholder": "host",
                "type": "string",
            },
            {
                "key": "milvus.port",
                "title": "Milvus Port",
                "label": "",
                "placeholder": "Port",
                "default": 19530,
                "type": "int",
            },
            {
                "key": "openSearch.endpoint",
                "title": "OpenSearch Host",
                "label": "",
                "placeholder": "host",
                "type": "string",
            },
            {
                "key": "openSearch.port",
                "title": "OpenSearch Port",
                "label": "",
                "placeholder": "Port",
                "default": 443,
                "type": "int",
            },
            {
                "key": "openSearch.region",
                "title": "OpenSearch AWS Region",
                "label": "",
                "placeholder": "Region",
                "default": 'us-east-1',
                "type": "string",
            },
            {
                "title": "Default Database",
                "key": "embeddings.database",
                "type": "dropdown",
                "placeholder": "Select mode",
                "forceValue": true,
                "options": [
                    {
                        "value": "opensearch",
                        "label": "OpenSearch",
                    },
                    {
                        "value": "milvus",
                        "label": "Milvus",
                    },
                ]
            }         
        ]
        frm.configOptions(mv, mvconfig, config);

        //// MISCELLANEOUS
        let nc = frm.configSection($('.panel2'), 'Miscellaneous', false);
        let mconfig = [
            {
                "key": "misc.obfuscateAnnotatorsThroughputReport",
                "title": "",
                "label": "Obfuscate Annotators/Reviewers Throughput Report",
                "type": "boolean",
                "default": false,
            },
            {
                "key": "misc.hideAnnotatorsThroughputReport",
                "title": "",
                "label": "Hide Annotators/Reviewers Throughput Report",
                "type": "boolean",
                "default": false,
            },
            {
                "key": "misc.disableAWSGlobalCredentials",
                "title": "",
                "label": "Disable AWS Global credentials option",
                "type": "boolean",
                "default": false,
            },
            {
                "key": "misc.freshwork_widget",
                "title": "",
                "label": "Show Support Icons",
                "type": "boolean",
                "default": false,
            },
            {
                "key": "quotas.concurrent_newton_ml",
                "title": "Max Concurrent Newton-ml processes",
                "label": "",
                "type": "int",
                "default": 10,
            },
            {
                "key": "quotas.concurrent_recipes",
                "title": "Max Concurrent Recipes",
                "label": "",
                "type": "int",
                "default": 10,
            },
            {
                "title": "Freshdesk API Key",
                "key": "misc.freshdesk_apikey",
                "placeholder": "Enter freshdesk API key",
                "default": "nRmNpZRb2Mk5IwPd09P",
                "type": "string"
            },
            {
                "key": "misc.enable_freshdesk_apikey",
                "title": "",
                "label": "Enable freshdesk ticket API",
                "type": "boolean",
                "default": false,
            }
        ]
        frm.configOptions(nc, mconfig, config);



        //// PASSWORD
        let pwc = frm.configSection($('.panel2'), 'Password Settings', false);
        let pwconfig = [
            {
                "key": "password.minLength",
                "title": "Minimum Password Length",
                "type": "number",
                "default": 0,
            },
            {
                "key": "password.minUpper",
                "title": "Minimum Upper Case Characters required",
                "type": "number",
                "default": 0,
            },
            {
                "key": "password.minLower",
                "title": "Minimum Lower Case Characters required",
                "type": "number",
                "default": 0,
            },
            {
                "key": "password.minDigit",
                "title": "Minimum Digit Characters required",
                "type": "number",
                "default": 0,
            },
            {
                "key": "password.minSymbol",
                "title": "Minimum Symbol Characters required",
                "type": "number",
                "default": 0,
            },
            {
                "key": "password.maxRepeat",
                "title": "Maximum repeating characters (0 = disabled)",
                "type": "number",
                "default": 0,
            },
            {
                "key": "password.maxSequence",
                "title": "Maximum character increment/decrement sequence allowed (0 = disabled)",
                "type": "number",
                "default": 0,
            },
            {
                "key": "password.maxContinuousType",
                "title": "Maximum continuous characters of the same type allowed (0 = disabled)",
                "type": "number",
                "default": 0,
            },
            {
                "key": "password.allowExtendedChars",
                "label": "Allow Extended characters (charcode &gt; 126)",
                "type": "boolean",
                "default": false,
            },
            {
                "key": "password.allowSpaces",
                "label": "Allow Space character",
                "type": "boolean",
                "default": false,
            },
            {
                "key": "password.checkDictionary",
                "label": "Check word dictionary",
                "type": "boolean",
                "default": false,
            },
            {
                "key": "password.checkLast3Passwords",
                "label": "Check for match on 3 previous passords",
                "type": "boolean",
                "default": false,
            },
            {
                "key": "password.forcePasswordChange",
                "title": "Force password change after N days (0 = disabled)",
                "type": "number",
                "default": 0,
            },
        ]
        frm.configOptions(pwc, pwconfig, config);

        //// EMAIL TEMPLATES
        let emc = frm.configSection($('.panel2'), 'Email Templates', false);
        let emconfig = []
        let templates = {
			'job_invitation': 'Project Team Invitation',
			'job_invitation_new_user': 'Project Team Invitation (new user)',
			'dataset_invitation': 'Dataset Team Invitation',
			'dataset_invitation_new_user': 'Dataset Team Invitation (new user)',
			'password_reset': 'Password Reset',
			'registration_code': 'Registration Code',
			'welcome': 'Welcome Message',
		}
        for( let t in templates ) {
            emconfig.push(
                {
                    "key": "emailTemplates."+t,
                    "title": templates[t],
                    "type": "textarea",
                    "placeholder": "Enter "+templates[t]+ " text",
                    "css": {height:150},
                }
            )
        }
        frm.configOptions(emc, emconfig, config);

        window.config = config;
    }

    function initConfig() {
        window.wizzardBar(true)
        frm.loading('Loading Configuration')
        window.post('get_config', {}, res => {
            frm.loadingOut();
            // var loadConfig = flatObject( res.data || {} );
            // for( var k in loadConfig ) setObject( config, k, loadConfig[k] )
            var loadConfig = res.data || {};
            config = { ...config, ...loadConfig }
            showConfig();
        })
    }

    useEffect(function (a) {
        initConfig();
        window.topBarVisible();
    }, []);

    return (
        <div fluid="md p-0" className="maincontent">
            <div className="row">
                <Col ssm={9} className="mt-3">
                    <div id="topbuttons"></div>
                    <div className="project-panel panel2">
                    </div>


                </Col>
            </div>
            <div className="wizzbtn"><button id="savebtn" className="btn btn-primary"> <i class=" mr-2 fa fa-floppy-o"></i>Save Config</button></div>
        </div>
    )
}

export default Config
